// extracted by mini-css-extract-plugin
export default {"controlButton":"_yWbO8","hidden":"U7HAnn","buttonWrapper":"TyEe6G","downloadButton":"JIFyFC","icon_small":"I1O8Nw","iconSmall":"I1O8Nw","icon_big":"CvohBz","iconBig":"CvohBz"};